import React from 'react'
import { Box, SpanStyled } from '../../Styled/Elements'
import { PrimaryHeading } from '../../Styled/CustomElements'
import { useTranslation } from 'react-i18next'
import { TabsWrapper } from './Styled'
import { WhyChooseItems } from '../../data/Data'

const TabThird = () => {
    const { t } = useTranslation();



    return (
        <TabsWrapper className='TabsAboutWrapper'>
            <Box className='tabInnerHeading'>
                <PrimaryHeading HlabelF={t("Why")} HlabelS={t("Choose_Us")} size='23px' />
            </Box>
            <SpanStyled size='15px' className='tabTxt'>
                {t('tab3_Text')}
            </SpanStyled>
            <Box className='whyChooseUsContainer'>
                {WhyChooseItems.map((item, index) => (
                    <Box key={index} className='whyChooseUsCol'>
                        <Box className="whyChooseUsImg">
                            {item.img}
                        </Box>
                        <Box className="whyChooseUsTxt">{t(item.expertiseTxt)}</Box>
                    </Box>
                ))}
                
                
            </Box>
        </TabsWrapper>
    )
}

export default TabThird
